export class ChaseAdvancePaymentTransactionStatus {
    transactionStatus: string;
    transactionId: string;
    advanceAmount: string;
    stationName: string;
    accountExecutiveName: string;
    agencyId: string;
    paymentMode: string;
}
